import { render, staticRenderFns } from "./ProgressReport.vue?vue&type=template&id=39ca11b3&scoped=true"
import script from "./ProgressReport.vue?vue&type=script&lang=js"
export * from "./ProgressReport.vue?vue&type=script&lang=js"
import style0 from "./ProgressReport.vue?vue&type=style&index=0&id=39ca11b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ca11b3",
  null
  
)

export default component.exports